<template>
    <div class="protein-selector d-flex justify-content-center flex-wrap gap-3 px-2">
        <div
            v-for="(product, key) in products"
            :key="key"
            class="protein-card d-flex flex-column align-items-center"
            @click="$emit('select', key)"
            role="button"
        >
            <div class="protein-img-wrap">
                <img :src="product.image" :alt="product.name" class="protein-img">
            </div>
            <span class="protein-name">{{ product.name }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProteinSelector',
    emits: ['select'],
    props: {
        products: { type: Object, required: true },
    },
};
</script>

<style scoped>
.protein-card {
    width: 100px;
    padding: 12px 8px;
    border-radius: 14px;
    background: #fff;
    border: 2px solid var(--nonagenary);
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.protein-card:hover {
    border-color: var(--primary);
    transform: translateY(-3px);
    box-shadow: 0 6px 16px rgba(232, 118, 43, 0.2);
}

.protein-card:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(232, 118, 43, 0.15);
}

.protein-img-wrap {
    width: 70px;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 6px;
}

.protein-img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    filter: drop-shadow(0 2px 3px rgba(0, 0, 0, 0.12));
}

.protein-name {
    font-size: 12px;
    font-weight: 700;
    color: var(--text6);
    text-align: center;
    line-height: 1.2;
}
</style>
